import { controls, currencyToNumber, grouped } from "../../controls";

const matchingstat = {
  label: "matchingstat",
  starting: true,
  url: "matchingstat",
  pageLabel: "Matching Statistics",
  pageType: "history",
  visitingBranches: true,
  filter: [
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Matching Statistics",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Village",
        accessor: "village_name",

      },
      {
        Header: "Taluka",
        accessor: "taluka_name",
      },
      {
        Header: "Portal Count",
        accessor: "portal_count"
      },
      {
        Header: "Saral Count",
        accessor: "saral_count"
      },
      {
        Header: "Auto Matched Count",
        accessor: "auto_matched"
      },
      {
        Header: "Manual Matched Count",
        accessor: "manual_matched"
      },
      {
        Header: "Suggested Count",
        accessor: "suggested"
      },
      {
        Header: "Above 5 Year Count",
        accessor: "above_5_year_count"
      }
    ]
  }
};

export default matchingstat;